import React, {Component} from 'react';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';

import cView from './cView';

//import i14v1a from './i14v1a';
//import c30v1a from './c30v1a';
//import c10v1b from './c10v1b';
//import c51v1a from './c51v1a';
import c20v1a from './c20v1a';

export default class iHome2 extends cView { // 団体用 home

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.d_viewDefs = {
      name: 'ホーム'
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

$clp_loadLists = () => [ // 親を上書き
  c20v1a.op_loadDtl({
    elm: 'c20r',
  }),
/*
  i14v1a.op_loadDtl({
    elm: 'i14r',
    fst: global.t?.state.sgcd_cmnStgs?.c20r_fst,
    op_atrAll: () => new Promise( _o_end1 => {
      let _d_i14rs = global.t?.state.sdld_i14rDtlsss.i14r[0];
      global.t?.setState({
        s_rsv1: _d_i14rs.d_flds.i14ri71s, // 設定説明文1
        s_rsv2: _d_i14rs.d_flds.i14ri81s, // 設定説明文2
        s_acn1: _d_i14rs.d_flds.i14ri72s, // 設定説明文1
        s_acn2: _d_i14rs.d_flds.i14ri82s, // 設定説明文2
        s_stg1: _d_i14rs.d_flds.i14ri73s, // 設定説明文1
      }, () => {
        _o_end1();
      })
    }),
  }),
*/
/*
  c10v1b.op_loadDtl({
    elm: 'c10r',
//    fst: global.t?.state.sgcd_cmnStgs?.c10r_fst,
    key: global.t?.state.sgcd_cmnStgs?.c10r_key,
    op_atrAll: () => new Promise( _o_end1 => {

      let _d_c10rs = global.t?.state.sdld_c10rDtlsss.c10r[0];

      let _rsvEndDate = 
        (_d_c10rs.d_flds.i15rt41i == 120) ? // 2週間後
          ff.myDT_add('day', ff.myDT_getDate('today'), 14)
        : (_d_c10rs.d_flds.i15rt41i == 130) ? // 3週間後
          ff.myDT_add('day', ff.myDT_getDate('today'), 21)
        : (_d_c10rs.d_flds.i15rt41i == 200) ? // 当月末
          ff.myDT_cnv('ldm', ff.myDT_getDate('today'))
        : (_d_c10rs.d_flds.i15rt41i == 210) ? // 一ヶ月後月末
          ff.myDT_cnv('ldm', ff.myDT_add('mth', ff.myDT_getDate('today'), 1))
        : (_d_c10rs.d_flds.i15rt41i == 210) ? // 二ヶ月後月末
          ff.myDT_cnv('ldm', ff.myDT_add('mth', ff.myDT_getDate('today'), 2))
        : null;

      global.t?.setState({
        s_i15rt32i: _d_c10rs.d_flds.i15rt32i ?? 0, // エントリー申込の可否
      }, () => {

        c51v1a.op_loadSlcList({
          elm: 'c51r',
          op_atrAll: 
            () => new Promise( _o_end2 => {

              let _tdy = ff.myDT_getDate('today');

              let _rsvSttDate = ff.myDT_add('day', _tdy, bf.n(c51v1a.o_getC51ri11s('01040400'))); // 予約受付終了日
              let _msg1 = `${_rsvSttDate} 〜 ${_rsvEndDate} 分を受付中`;

              let _alyThisMth = ff.myDT_add('mth', ff.myDT_cnv('fdm', _tdy), 2).substr(0, 7); // 予約受付開始日
              let _alyThisSttDate = ff.myDT_add('day', ff.myDT_cnv('fdm', _tdy), bf.n(c51v1a.o_getC51ri11s('02040100')) - 1); // 予約受付開始日
              let _alyThisEndDate = ff.myDT_add('day', ff.myDT_cnv('fdm', _tdy), bf.n(c51v1a.o_getC51ri11s('02040200')) - 1); // 予約受付終了日
              let _alyNextMth = ff.myDT_add('mth', ff.myDT_cnv('fdm', _tdy), 3).substr(0, 7); // 予約受付開始日
              let _alyNextSttDate = ff.myDT_add('day', ff.myDT_cnv('fdm', ff.myDT_add('mth', _tdy, 1)), bf.n(c51v1a.o_getC51ri11s('02040100')) - 1); // 予約受付開始日
              let _alyNextEndDate = ff.myDT_add('day', ff.myDT_cnv('fdm', ff.myDT_add('mth', _tdy, 1)), bf.n(c51v1a.o_getC51ri11s('02040200')) - 1); // 予約受付終了日
              let _msg2 = null;
              if ( _tdy < _alyThisSttDate) { // エントリー期間前
                _msg2 = `${_alyThisMth} 分を ${_alyThisSttDate} から受付予定`
              }
              else if ( _tdy >= _alyThisSttDate && _tdy <= _alyThisEndDate) { // エントリー期間
                _msg2 = `${_alyThisMth} 分を ${_alyThisEndDate} まで受付中`
              }
              else { // エントリー期間後
                _msg2 = `${_alyNextMth} 分を ${_alyNextSttDate} から受付予定`
              }

              let _d = {
                s_msg1: _msg1,
                s_msg2: _msg2,
              };
              cf.myRN_setStt(_d)
              .then(_o_end2);      
            })
        })
        .then(_o_end1);
      })
    }),
  })
*/
/*
  c30v1a.op_loadDtl({
    elm: 'c30r',
    key: global.t?.state.sgcd_cmnStgs?.c10r_key,
    key: global.t?.state.sgcd_cmnStgs?.c10r_key,
  }),
*/
];

  render() {
    return (
      ce.c(ce.RootDtl, {
        key: -1,
        d_hdrs: {
//          pfx: 'ホーム',
          pfx: `${global.t?.state.sgcd_stgs?.clt ?? ''} 施設利用予約・ホーム`,
/*
          d_subs: 
            ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) == false ?
              {
                iconName: 'users',
                pfx: 'ユーザ切替',
                o_onPrs: () => {
                  let _d_pageInfs = {
                    sgc_pageRole: global.t?.state.sgc_pageRole,
                    sgc_pageName: 'c00v2a',
                    sgc_pageMode: 'show',
                  };
                  cf.myRN_move_fwd(_d_pageInfs);
                },
              }
            : null,
*/
        },
        d_bdys: {

          stlCta: {
            height: ic.gn_bdyH,
            width: '100%',
            flexDirection: 'column',
            justifyContent: (ic.g_dvcMode == 's') ? 'flex-start' : 'flex-start',
            alignItems: 'center',
            marginTop: (ic.g_dvcMode == 's') ? null : ic.s(5)
          },
          l_clds: [

            ce.c(ce.Msg, {
              key: -10,
              b_vsb: true,
              true : false,
              pfx: `団体名：${(global.t?.state.sdld_c30rDtlsss?.c30r[0]) ? global.t?.state.sdld_c30rDtlsss?.c30r[0].d_flds.c30rc31s : ''}`,
              stlCta: {
                marginTop: ic.s(1),
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              },
              stlPfx: {
                textAlign: 'center',
              },
            }),

            ce.c(ce.Box, {
              key: -20,
              d_stlCtas :{
                marginTop: ic.s(1),
                width: ic.gn_bdyW,
                maxWidth: ic.gn_minBdyW * 2,
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                borderColor: 'black',
                borderWidth: ic.b(0.5),
                padding: ic.s(0.5),
              },
            }, [
              ce.c(ce.Msg, {
                key: -10,
                pfx: global.t?.state.sgcd_stgs?._00010100,
                stlCta: {
                  width: ic.gn_bdyW,
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: ic.m(1),
                },
                stlPfx: {
                  textAlign: 'center',
                },
              }),
            ]),

            ce.c(ce.Spr, {
              key: -30,
              d_stlCtas: {
                marginTop: ic.s(2),
                marginBottom: ic.s(3),
              },
            }),

            ce.c(ce.Box, {
              key: -40,
              stlCta: {
                flexDirection: (ic.g_dvcMode == 's') ? 'column' : 'row',
                justifyContent: (ic.g_dvcMode == 's') ? 'space-around' : 'space-between',
                alignItems: (ic.g_dvcMode == 's') ? 'space-around' : 'flex-start',
              }
            }, [

              ce.c(ce.Box, {
                key: -10,
                b_vsb: (global.t?.state.sgcd_stgs?.b_pryAbl == true) ? true : false,
                stlCta: {
                  height: ic.s(18),
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }
              }, [

                ce.c(ce.Btn, {
                  key: -2,
                  b_vsb: true,
                  b_rvs: false,
                  pfx: '優先エントリー',
                  o_onPrs: () => {
                    let _d_pageInfs = {
                      sgc_pageRole: 'mmb1',
                      sgc_pageName: 'i1zv2c',
                      sgc_pageMode: 'show',
                    };
                    cf.myRN_move_fwd(_d_pageInfs);
                  },
                  stlCta: {
                    height: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                  },
                  stlBtn: {
                    height: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                    width: ic.gn_btnWLrg * 2,
                  },
                  stlPfx: {
                    lineHeight: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                  },
                }),

                ce.c(ce.Msg, {
                  key: -3,
//                  pfx: global.t?.state.sgcd_stgs?._00030100,
                  pfx: global.t?.state.sgcd_stgs?._00090100,
                  stlCta: {
                    height: ic.s(3),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  },
                  stlPfx: {
                    textAlign: 'center',
                    fontWeight: 'bold',
                  },
                }),

                ce.c(ce.Msg, {
                  key: -1,
//                  pfx: global.t?.state.sgcd_stgs?.alyMsg1,
                  pfx: global.t?.state.sgcd_stgs?.pryMsg1,
                  stlCta: {
                    height: ic.s(4),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    marginBottom: ic.m(1),
                    paddingLeft: ic.m(1),
                    paddingRight: ic.m(1),
                  },
                  stlPfx: {
                    textAlign: 'center',
                    color: ic.o_getCcd('e'),
                    fontSize: ic.s(1.2),
                    fontWeight: 'bold'
                  },
                }),

                ce.c(ce.Msg, {
                  key: -4,
//                  pfx: global.t?.state.sgcd_stgs?._00030200,
                  pfx: global.t?.state.sgcd_stgs?._00090200,
                  stlCta: {
                    height: ic.s(10),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  },
                  stlPfx: {
                    fontSize: ic.gn_fontSizeSml,
                    textAlign: 'center',
                  },
                }),
              
              ]),

              ce.c(ce.Box, {
                key: -20,
                b_vsb: (global.t?.state.sgcd_stgs?.b_alyAbl == true) ? true : false,
                stlCta: {
                  height: ic.s(18),
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }
              }, [

                ce.c(ce.Btn, {
                  key: -2,
                  b_vsb: true,
                  b_rvs: false,
                  pfx: 'エントリー',
                  o_onPrs: () => {
                    let _d_pageInfs = {
                      sgc_pageRole: 'mmb1',
                      sgc_pageName: 'i1zv2b',
                      sgc_pageMode: 'show',
                    };
                    cf.myRN_move_fwd(_d_pageInfs);
                  },
                  stlCta: {
                    height: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                  },
                  stlBtn: {
                    height: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                    width: ic.gn_btnWLrg * 2,
                  },
                  stlPfx: {
                    lineHeight: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                  },
                }),

                ce.c(ce.Msg, {
                  key: -3,
                  pfx: global.t?.state.sgcd_stgs?._00030100,
                  stlCta: {
                    height: ic.s(3),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  },
                  stlPfx: {
                    textAlign: 'center',
                    fontWeight: 'bold',
                  },
                }),

                ce.c(ce.Msg, {
                  key: -1,
                  pfx: global.t?.state.sgcd_stgs?.alyMsg1,
                  stlCta: {
                    height: ic.s(4),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    marginBottom: ic.m(1),
                    paddingLeft: ic.m(1),
                    paddingRight: ic.m(1),
                  },
                  stlPfx: {
                    textAlign: 'center',
                    color: ic.o_getCcd('e'),
                    fontSize: ic.s(1.2),
                    fontWeight: 'bold'
                  },
                }),

                ce.c(ce.Msg, {
                  key: -4,
                  pfx: global.t?.state.sgcd_stgs?._00030200,
                  stlCta: {
                    height: ic.s(10),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  },
                  stlPfx: {
                    fontSize: ic.gn_fontSizeSml,
                    textAlign: 'center',
                  },
                }),
              
              ]),

              ce.c(ce.Box, {
                key: -30,
                stlCta: {
                  height: ic.s(18),
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }
              }, [

                ce.c(ce.Btn, {
                  key: -2,
                  b_vsb: true,
                  b_rvs: false,
                  pfx: `直接予約`,
                  o_onPrs: () => {
                    let _d_pageInfs = {
                      sgc_pageRole: 'mmb1',
                      sgc_pageName: 'i1zv2a',
                      sgc_pageMode: 'show',
                    };
                    cf.myRN_move_fwd(_d_pageInfs);
                  },
                  stlCta: {
                    height: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                  },
                  stlBtn: {
                    height: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                    width: ic.gn_btnWLrg * 2,
                  },
                  stlPfx: {
                    lineHeight: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                  },
                }),

                ce.c(ce.Msg, {
                  key: -3,
                  pfx: global.t?.state.sgcd_stgs?._00020100,
                  stlCta: {
                    height: ic.s(3),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  },
                  stlPfx: {
                    textAlign: 'center',
                    fontWeight: 'bold',
                  },
                }),

                ce.c(ce.Msg, {
                  key: -1,
                  pfx: global.t?.state.sgcd_stgs?.rsvMsg1,
                  stlCta: {
                    height: ic.s(4),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    marginBottom: ic.m(1),
                    paddingLeft: ic.m(1),
                    paddingRight: ic.m(1),
                  },
                  stlPfx: {
                    textAlign: 'center',
                    color: ic.o_getCcd('e'),
                    fontSize: ic.s(1.2),
                    fontWeight: 'bold'
                  },
                }),

                ce.c(ce.Msg, {
                  key: -4,
                  pfx: global.t?.state.sgcd_stgs?._00020200,
                  stlCta: {
                    height: ic.s(10),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  },
                  stlPfx: {
                    fontSize: ic.gn_fontSizeSml,
                    textAlign: 'center',
                  },
                }),

              ]),

/*
              ce.c(ce.Box, {
                key: -40,
                stlCta: {
                  height: ic.s(18),
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }
              }, [

                ce.c(ce.Btn, {
                  key: -2,
                  b_vsb: true,
                  b_rvs: false,
                  pfx: '設定',
                  o_onPrs: () => {
                    let _d_pageInfs = {
                      sgc_pageRole: 'mmb1',
                      sgc_pageName: 'c30v2a',
                      sgc_pageMode: 'show',
                    };
                    cf.myRN_move_fwd(_d_pageInfs);
                  },
                  stlCta: {
                    height: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                  },
                  stlBtn: {
                    height: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                    width: ic.gn_btnWLrg * 2,
                  },
                  stlPfx: {
                    lineHeight: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                  },
                }),

                ce.c(ce.Msg, {
                  key: -3,
                  pfx: global.t?.state.sgcd_stgs?._00040100,
                  stlCta: {
                    height: ic.s(3),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  },
                  stlPfx: {
                    textAlign: 'center',
                    fontWeight: 'bold',
                  },
                }),

                ce.c(ce.Msg, {
                  key: -1,
                  pfx: ' ',
                  stlCta: {
                    height: ic.s(4),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  },
                  stlPfx: {
                    textAlign: 'center',
                  },
                }),

                ce.c(ce.Msg, {
                  key: -4,
                  pfx: global.t?.state.sgcd_stgs?._00040200,
                  stlCta: {
                    height: ic.s(10),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  },
                  stlPfx: {
                    fontSize: ic.gn_fontSizeSml,
                    textAlign: 'center',
                  },
                }),

              ]),
*/

            ]),

            ce.c(ce.Box, {
              key: -50,
              stlCta: {
                marginTop: (ic.g_dvcMode == 's') ? 0 : ic.s(3),
                flexDirection: (ic.g_dvcMode == 's') ? 'column' : 'row',
                justifyContent: (ic.g_dvcMode == 's') ? 'space-around' : 'space-between',
                alignItems: (ic.g_dvcMode == 's') ? 'space-around' : 'flex-start',
              }
            }, [

/*
              ce.c(ce.Box, {
                key: -10,
                b_vsb: (global.t?.state.sgcd_stgs?.b_pryAbl == true) ? true : false,
                stlCta: {
                  height: ic.s(18),
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }
              }, [

                ce.c(ce.Btn, {
                  key: -2,
                  b_vsb: true,
                  b_rvs: false,
                  pfx: '優先エントリー',
                  o_onPrs: () => {
                    let _d_pageInfs = {
                      sgc_pageRole: 'mmb1',
                      sgc_pageName: 'i1zv2c',
                      sgc_pageMode: 'show',
                    };
                    cf.myRN_move_fwd(_d_pageInfs);
                  },
                  stlCta: {
                    height: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                  },
                  stlBtn: {
                    height: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                    width: ic.gn_btnWLrg * 2,
                  },
                  stlPfx: {
                    lineHeight: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                  },
                }),

                ce.c(ce.Msg, {
                  key: -3,
//                  pfx: global.t?.state.sgcd_stgs?._00030100,
                  pfx: global.t?.state.sgcd_stgs?._00090100,
                  stlCta: {
                    height: ic.s(3),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  },
                  stlPfx: {
                    textAlign: 'center',
                    fontWeight: 'bold',
                  },
                }),

                ce.c(ce.Msg, {
                  key: -1,
//                  pfx: global.t?.state.sgcd_stgs?.alyMsg1,
                  pfx: global.t?.state.sgcd_stgs?.pryMsg1,
                  stlCta: {
                    height: ic.s(4),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    marginBottom: ic.m(1),
                    paddingLeft: ic.m(1),
                    paddingRight: ic.m(1),
                  },
                  stlPfx: {
                    textAlign: 'center',
                    color: ic.o_getCcd('e'),
                    fontSize: ic.s(1.2),
                    fontWeight: 'bold'
                  },
                }),

                ce.c(ce.Msg, {
                  key: -4,
//                  pfx: global.t?.state.sgcd_stgs?._00030200,
                  pfx: global.t?.state.sgcd_stgs?._00090200,
                  stlCta: {
                    height: ic.s(10),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  },
                  stlPfx: {
                    fontSize: ic.gn_fontSizeSml,
                    textAlign: 'center',
                  },
                }),
              
              ]),

              ce.c(ce.Box, {
                key: -20,
                b_vsb: (global.t?.state.sgcd_stgs?.b_alyAbl == true) ? true : false,
                stlCta: {
                  height: ic.s(18),
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }
              }, [

                ce.c(ce.Btn, {
                  key: -2,
                  b_vsb: true,
                  b_rvs: false,
                  pfx: 'エントリー',
                  o_onPrs: () => {
                    let _d_pageInfs = {
                      sgc_pageRole: 'mmb1',
                      sgc_pageName: 'i1zv2b',
                      sgc_pageMode: 'show',
                    };
                    cf.myRN_move_fwd(_d_pageInfs);
                  },
                  stlCta: {
                    height: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                  },
                  stlBtn: {
                    height: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                    width: ic.gn_btnWLrg * 2,
                  },
                  stlPfx: {
                    lineHeight: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                  },
                }),

                ce.c(ce.Msg, {
                  key: -3,
                  pfx: global.t?.state.sgcd_stgs?._00030100,
                  stlCta: {
                    height: ic.s(3),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  },
                  stlPfx: {
                    textAlign: 'center',
                    fontWeight: 'bold',
                  },
                }),

                ce.c(ce.Msg, {
                  key: -1,
                  pfx: global.t?.state.sgcd_stgs?.alyMsg1,
                  stlCta: {
                    height: ic.s(4),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    marginBottom: ic.m(1),
                    paddingLeft: ic.m(1),
                    paddingRight: ic.m(1),
                  },
                  stlPfx: {
                    textAlign: 'center',
                    color: ic.o_getCcd('e'),
                    fontSize: ic.s(1.2),
                    fontWeight: 'bold'
                  },
                }),

                ce.c(ce.Msg, {
                  key: -4,
                  pfx: global.t?.state.sgcd_stgs?._00030200,
                  stlCta: {
                    height: ic.s(10),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  },
                  stlPfx: {
                    fontSize: ic.gn_fontSizeSml,
                    textAlign: 'center',
                  },
                }),
              
              ]),

              ce.c(ce.Box, {
                key: -30,
                stlCta: {
                  height: ic.s(18),
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }
              }, [

                ce.c(ce.Btn, {
                  key: -2,
                  b_vsb: true,
                  b_rvs: false,
                  pfx: `直接予約`,
                  o_onPrs: () => {
                    let _d_pageInfs = {
                      sgc_pageRole: 'mmb1',
                      sgc_pageName: 'i1zv2a',
                      sgc_pageMode: 'show',
                    };
                    cf.myRN_move_fwd(_d_pageInfs);
                  },
                  stlCta: {
                    height: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                  },
                  stlBtn: {
                    height: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                    width: ic.gn_btnWLrg * 2,
                  },
                  stlPfx: {
                    lineHeight: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                  },
                }),

                ce.c(ce.Msg, {
                  key: -3,
                  pfx: global.t?.state.sgcd_stgs?._00020100,
                  stlCta: {
                    height: ic.s(3),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  },
                  stlPfx: {
                    textAlign: 'center',
                    fontWeight: 'bold',
                  },
                }),

                ce.c(ce.Msg, {
                  key: -1,
                  pfx: global.t?.state.sgcd_stgs?.rsvMsg1,
                  stlCta: {
                    height: ic.s(4),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    marginBottom: ic.m(1),
                    paddingLeft: ic.m(1),
                    paddingRight: ic.m(1),
                  },
                  stlPfx: {
                    textAlign: 'center',
                    color: ic.o_getCcd('e'),
                    fontSize: ic.s(1.2),
                    fontWeight: 'bold'
                  },
                }),

                ce.c(ce.Msg, {
                  key: -4,
                  pfx: global.t?.state.sgcd_stgs?._00020200,
                  stlCta: {
                    height: ic.s(10),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  },
                  stlPfx: {
                    fontSize: ic.gn_fontSizeSml,
                    textAlign: 'center',
                  },
                }),

              ]),
*/

              ce.c(ce.Box, {
                key: -40,
                stlCta: {
                  height: ic.s(18),
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }
              }, [

                ce.c(ce.Btn, {
                  key: -2,
                  b_vsb: true,
                  b_rvs: false,
                  pfx: '設定',
                  o_onPrs: () => {
                    let _d_pageInfs = {
                      sgc_pageRole: 'mmb1',
                      sgc_pageName: 'c30v2a',
                      sgc_pageMode: 'show',
                    };
                    cf.myRN_move_fwd(_d_pageInfs);
                  },
                  stlCta: {
                    height: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                  },
                  stlBtn: {
                    height: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                    width: ic.gn_btnWLrg * 2,
                  },
                  stlPfx: {
                    lineHeight: ic.s(3) * ((ic.g_dvcMode == 's') ? 1 : 2),
                  },
                }),

                ce.c(ce.Msg, {
                  key: -3,
                  pfx: global.t?.state.sgcd_stgs?._00040100,
                  stlCta: {
                    height: ic.s(3),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  },
                  stlPfx: {
                    textAlign: 'center',
                    fontWeight: 'bold',
                  },
                }),

                ce.c(ce.Msg, {
                  key: -1,
                  pfx: ' ',
                  stlCta: {
                    height: ic.s(4),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  },
                  stlPfx: {
                    textAlign: 'center',
                  },
                }),

                ce.c(ce.Msg, {
                  key: -4,
                  pfx: global.t?.state.sgcd_stgs?._00040200,
                  stlCta: {
                    height: ic.s(10),
                    width: ic.gn_minBdyW,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  },
                  stlPfx: {
                    fontSize: ic.gn_fontSizeSml,
                    textAlign: 'center',
                  },
                }),

              ]),

            ]),

          ]
        }
      })
    );
  };
};


